<template>
  <ItemPage
    title="Cargos"
    size="sm"
    :actions="actions"
  >
    <v-container v-if="rolesView">
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisa"
            single-line
            hide-details
          />
        </v-col>
      </v-row>
    </v-container>
    <v-simple-table
      v-if="rolesView"
      fixed-header
    >
      <template v-if="loading">
        <Load :loading-msg="loadingMsg" />
      </template>
      <div
        v-else
        class="mr-5 ml-5"
      >
        <v-data-table
          :headers="headers"
          :items="roles"
          :items-per-page="10"
          :search="search"
          item-key="id"
          @click:row="permissions($event)"
        />
      </div>
    </v-simple-table>
    <template v-else>
      usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import NewRoleDialog from './NewRoleDialog.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import Load from '@/components/Loading.vue'
import utils from '@/api/utils.js'

export default {
  components: {
    Load, ItemPage
  },
  data () {
    return {
      rolesCreate: true,
      rolesView: true,
      updateRole: true,
      loading: false,
      loadingMsg: '',
      roles: [],
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          value: 'display_name'
        },
        {
          text: 'Código',
          align: 'start',
          value: 'name'
        }
      ]
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Adicionar Cargo',
          action: this.openNewRoleDialog,
          icon: 'mdi-plus',
          disabled: !this.rolesCreate
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.getRoles()
      this.rolesCreate = utils.checkPermissions('roles.create')
      this.rolesView = utils.checkPermissions('roles.view-any')
    },
    checkPermission (permission) {
      return utils.checkPermissions(permission)
    },
    async getRoles () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        const roles = await this.$api.getRoles()
        this.roles = roles
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível listar os cargos, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    permissions (event) {
      this.$router.push({ name: 'cargos.id', params: { id: event.id } })
    },

    openNewRoleDialog () {
      this.$dialog.custom(NewRoleDialog).show()
        .then((role) => {
          if (!role) {
            return
          }
          this.newRole(role)
        })
    },
    async newRole (data) {
      try {
        await this.$api.newRole(data)
        this.$store.dispatch('setSnackBar', { text: 'Salvo com sucesso.' })
        this.fetchAll()
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
